import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState, BaasicButton } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content, PageNavigation } from 'core/layouts';

function OrderingDoctorListTemplate({ orderingDoctorListViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization,
        sync
    } = orderingDoctorListViewStore;
    return (
        <ApplicationListLayout store={orderingDoctorListViewStore}>
            <PageNavigation>
                <BaasicButton authorized={authorization ? authorization.create : true} className="btn btn--base btn--primary" label={'Sync'} icon="u-icon u-icon--sml u-icon--synchronize" onClick={sync} disabled={tableStore.loading}></BaasicButton>               
            </PageNavigation>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} />
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='ORDERING_DOCTOR.LIST.EMPTY_STATE.TITLE' description='ORDERING_DOCTOR.LIST.EMPTY_STATE.DESCRIPTION' />
}

OrderingDoctorListTemplate.propTypes = {
    orderingDoctorListViewStore: PropTypes.object
};

export default defaultTemplate(OrderingDoctorListTemplate);
